import React from 'react';
import { Link } from 'react-router-dom';
import heroBg from '../assets/hero-bg.png';

export default function LandingPage() {
  return (
    <div className="relative overflow-hidden min-h-screen flex items-center justify-center">

      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src={heroBg}
          alt="City Road Network"
          className="w-full h-full object-cover opacity-30 dark:opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-dark-900 via-dark-900/80 to-dark-900/90 dark:from-dark-900 dark:via-dark-900/60 dark:to-dark-900/80 mix-blend-multiply"></div>
        <div className="absolute inset-0 bg-radial-gradient from-transparent to-dark-900/90"></div>
      </div>

      {/* Content container */}
      <div className="relative max-w-5xl mx-auto px-6 py-12 md:py-24 text-center z-10 font-[Inter,sans-serif]">
        <div className="mb-6 md:mb-8 inline-block">
          <span className="px-3 py-1.5 md:px-4 md:py-1.5 rounded-full border border-primary-500/30 bg-primary-500/10 text-primary-500 text-xs md:text-sm font-bold tracking-wide uppercase shadow-lg shadow-primary-500/10 backdrop-blur-md">
            Community-Driven Road Safety
          </span>
        </div>

        <h1 className="text-4xl sm:text-5xl md:text-7xl font-display font-extrabold leading-tight mb-4 md:mb-6 text-main drop-shadow-lg">
          Make Your City <br className="hidden md:block" />
          <span className="bg-gradient-to-r from-primary-500 via-indigo-500 to-accent-500 bg-clip-text text-transparent filter drop-shadow-sm">
            Smoother & Safer
          </span>
        </h1>

        <p className="mt-4 md:mt-6 text-lg sm:text-xl md:text-2xl max-w-3xl mx-auto text-muted font-light leading-relaxed drop-shadow-md">
          Join thousands of citizens reporting potholes and hazards. Help authorities prioritize repairs with real-time, transparent data.
        </p>

        <div className="mt-8 md:mt-12 flex flex-col sm:flex-row justify-center gap-4 md:gap-6 w-full max-w-xs sm:max-w-none mx-auto">
          <Link
            to="/register"
            className="group relative w-full sm:w-auto px-8 py-3.5 md:py-4 bg-gradient-to-r from-primary-600 to-indigo-600 text-white font-bold text-base md:text-lg rounded-xl md:rounded-2xl shadow-xl shadow-primary-600/30 overflow-hidden transition-all duration-300 hover:-translate-y-1 hover:shadow-primary-600/50 flex justify-center items-center"
          >
            <span className="relative z-10 flex items-center gap-2">
              Get Started Now
              <svg className="w-5 h-5 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" /></svg>
            </span>
          </Link>

          <Link
            to="/reports"
            className="w-full sm:w-auto px-8 py-3.5 md:py-4 bg-white/5 backdrop-blur-md border border-white/10 text-main font-bold text-base md:text-lg rounded-xl md:rounded-2xl transition-all duration-300 hover:-translate-y-1 hover:bg-white/10 hover:shadow-lg flex justify-center items-center"
          >
            View Live Map
          </Link>
        </div>
      </div>
    </div>
  );
}
